export const list2Tree = (list, key, parentKeyName, sortKey) => {
    let roots = list.filter(item => item[parentKeyName] === -1).sort((a, b) => a[sortKey] - b[sortKey])
    if (roots) {
        roots.sort((a, b) => a[sortKey] - b[sortKey])
    }
    for (const item of roots) {
        item.children = findChildren(list, key, parentKeyName, item[key], sortKey)
    }
    return roots
}

const findChildren = (list, key, parentKeyName, parentKeyValue, sortKey) => {
    let children = list.filter(item => item[parentKeyName] === parentKeyValue)
    if (children.length === 0) {
        return null
    }
    children.sort((a, b) => a[sortKey] - b[sortKey])
    for (const item of children) {
        item.children = findChildren(list, key, parentKeyName, item[key], sortKey)
        if (item.children) {
            item.children.sort((a, b) => a[sortKey] - b[sortKey])
        }
    }
    return children
}